export function isTaskNotification(notification) {
  return (Object.prototype.hasOwnProperty.call(notification, 'task_new') ||
    Object.prototype.hasOwnProperty.call(notification, 'task_due') ||
    Object.prototype.hasOwnProperty.call(notification, 'task_overdue') ||
    Object.prototype.hasOwnProperty.call(notification, 'task_assigned')
  );
}
